// Square logo badge overlaid on the bottom-left corner of a large hero photo.
// `bg` controls the fill + matching border: "clear" (transparent, no border/shadow),
// "black" (black fill + black border), or "white" (white fill + white border).
// When `bg` is not one of these, we fall back to the legacy look (transparent
// fill + thin black border) so existing listings are unchanged.
export default function HeroLogoBadge({ src, alt = "", fit = "contain", bg, testid = "hero-logo-badge" }) {
    if (!src) return null;
    const SHADOW = "shadow-[0_4px_20px_rgba(0,0,0,0.45)]";
    const style = {
        // "Clear" = perfectly transparent: no fill, no border, no shadow, no padding.
        clear: { box: "bg-transparent border-0", pad: "p-0", shadow: "" },
        black: { box: "bg-black border-2 border-black", pad: "p-1.5", shadow: SHADOW },
        white: { box: "bg-white border-2 border-white", pad: "p-1.5", shadow: SHADOW },
    }[bg] || { box: "bg-transparent border-2 border-black", pad: "p-0", shadow: SHADOW };
    return (
        <div
            data-testid={testid}
            className={`absolute bottom-3 left-3 sm:bottom-4 sm:left-4 h-20 w-20 sm:h-24 sm:w-24 overflow-hidden flex items-center justify-center ${style.box} ${style.shadow}`}
        >
            <img
                src={src}
                alt={alt}
                className={`w-full h-full ${style.pad} ${fit === "cover" ? "object-cover" : "object-contain"}`}
                onError={(e) => { e.currentTarget.parentElement.style.display = "none"; }}
            />
        </div>
    );
}
